import React, { Component } from "react";
// import html2canvas from "html2canvas";
import moment from "moment";
import TotalViews from "./TotalViews";
import TotalViewsBySection from "./TotalViewsBySection";
import TotalViewsByDevice from "./TotalViewsByDevice";
import TotalLikes from "./TotalLikes";
import TotalLikesByLike from "./TotalLikesByLike";
import TotalLikesBySource from "./TotalLikesBySource";
import TotalEngagement from "./TotalEngagement";
import TotalReach from "./TotalReach";
import TotalPostLikes from "./TotalPostLikes";
import TotalAudienceByGender from "./TotalAudienceByGender";
import TotalAudienceByCountry from "./TotalAudienceByCountry";
import TotalAudienceByAge from "./TotalAudienceByAge";
import { toTitleCase } from "../Dashboard/Charts/utils";
import FBPostsOvertimeChart from "./FBPostsOvertimeChart";
import TotalImpression from "./TotalImpression";

export const pageViewTabpanes = [
    { menuItem: "Total Views", chartsList: ["totalViews"] },
    { menuItem: "By Section", chartsList: ["totalViewsBySection"] },
    { menuItem: "By Device", chartsList: ["totalViewsByDevice"] },
];

export const pageLikesTabpanes = [
    { menuItem: "Total Followers", chartsList: ["totalLikes"] },
    // { menuItem: 'BY LIKE TYPE', chartsList: ['totalLikesByLike'] },
    // { menuItem: 'BY SOURCE TYPE', chartsList: ['totalLikesBySource'] },
];

export const postsOverTime = [{ menuItem: "Posts over Time", chartsList: ["fbPostOvertime"] }];

export const pageEngagementTabpanes = [{ menuItem: "Total Engagement", chartsList: ["totalEngagement"] }];

export const pageReachTabpanes = [{ menuItem: "Total Reach", chartsList: ["totalReach"] }];
export const pageImpressionTabpanes = [{ menuItem: "Total Impression", chartsList: ["totalImpression"] }];

export const postLikesTabpanes = [{ menuItem: "Total Likes", chartsList: ["totalPostLikes"] }];

export const audienceByGenderTabpanes = [{ menuItem: "Total Audience by Gender", chartsList: ["totalAudienceByGender"] }];

export const audienceByCountryTabpanes = [{ menuItem: "Total Audience by Country", chartsList: ["totalAudienceByCountry"] }];

export const audienceByAgeTabpanes = [{ menuItem: "Total Audience by Age", chartsList: ["totalAudienceByAge"] }];

export const fbViewCharts = [
    { name: "totalViews", title: "TOTAL VIEWS", component: TotalViews, api: "totalViews" },
    // { name: "fbinsights:totalViews", title: "TOTAL VIEWS", component: CustomTotalPageView, api: "totalViews" },
    { name: "totalViewsBySection", title: "TOTAL VIEWS BY SECTION", component: TotalViewsBySection, api: "totalViewsBySection" },
    { name: "totalViewsByDevice", title: "TOTAL VIEWS BY DEVICE", component: TotalViewsByDevice, api: "totalViewsByDevice" },
    // { name: "totalViewsBySection", title: "TOTAL VIEWS BY SECTION", component: TotalViewsBySection, api: "totalViewsBySection" },
    // { name: "fbinsights:totalViewsBySection", title: "TOTAL VIEWS BY SECTION", component: CustomTotalViewsBySection, api: "totalViewsBySection" },
    // { name: "totalViewsByDevice", title: "TOTAL VIEWS BY DEVICE", component: TotalViewsByDevice, api: "totalViewsByDevice" },
    // { name: "fbinsights:totalViewsByDevice", title: "TOTAL VIEWS BY DEVICE", component: CustomTotalViewsByDevice, api: "totalViewsByDevice" },
];

export const fbLikesCharts = [
    { name: "totalLikes", title: "TOTAL LIKES", component: TotalLikes, api: "totalLikes" },
    { name: "totalLikesByLike", title: "TOTAL LIKES BY LIKE", component: TotalLikesByLike, api: "totalLikesByLike" },
    { name: "totalLikesBySource", title: "TOTAL LIKES BY SOURCE", component: TotalLikesBySource, api: "totalLikesBySource" },
];

export const fbEngagementCharts = [
    { name: "totalEngagement", title: "TOTAL ENGAGEMENT", component: TotalEngagement, api: "totalEngagement" },
    // { name: "fbinsights:totalLikes", title: "PAGE FOLLOWERS CHANGE OVER TIME", component: CustomTotalPageFollowers, api: "totalLikes" },
    // { name: "fbinsights:totalEngagement", title: "PAGE ENGAGEMENTS OVER TIME", component: CustomTotalEngagement, api: "totalLikes" },
];

export const fbReachCharts = [
    { name: "totalReach", title: "TOTAL REACH", component: TotalReach, api: "totalReach" },
    // { name: "fbinsights:totalReach", title: "TOTAL REACH", component: CustomTotalReach, api: "totalReach" },
];

export const fbImpressionCharts = [
    { name: "totalImpression", title: "TOTAL Impression", component: TotalImpression, api: "totalImpression" },
    // { name: "fbinsights:totalReach", title: "TOTAL REACH", component: CustomTotalReach, api: "totalReach" },
];

export const fbPostLikesCharts = [
    { name: "totalPostLikes", title: "TOTAL LIKES", component: TotalPostLikes, api: "totalPostLikes" },
    // { name: "fbinsights:totalPostLikes", title: "TOTAL LIKES", component: CustomTotalPostLikes, api: "totalPostLikes" },
];

export const fbPostOverTimeCharts = [{ name: "fbPostOvertime", title: "Posts over Time", component: FBPostsOvertimeChart }];

export const audienceByGenderCharts = [
    { name: "totalAudienceByGender", title: "TOTAL AUDIENCE BY GENDER", component: TotalAudienceByGender, api: "totalAudienceByGender" },
];

export const audienceByCountryCharts = [
    { name: "totalAudienceByCountry", title: "TOTAL AUDIENCE BY COUNTRY", component: TotalAudienceByCountry, api: "totalAudienceByCountry" },
];

export const audienceByAgeCharts = [{ name: "totalAudienceByAge", title: "TOTAL AUDIENCE BY AGE", component: TotalAudienceByAge, api: "totalAudienceByAge" }];

export const getFbViewChart = (name) => {
    return fbViewCharts.find((fbViewChart) => fbViewChart.name === name);
};

export const getFbLikesChart = (name) => {
    return fbLikesCharts.find((fbLikesChart) => fbLikesChart.name === name);
};

export const getFbPostsOvertimeChart = (name) => {
    return fbPostOverTimeCharts.find((fbLikesChart) => fbLikesChart.name === name);
};

export const getFbEngagementChart = (name) => {
    return fbEngagementCharts.find((fbEngagementChart) => fbEngagementChart.name === name);
};

export const getFbReachChart = (name) => {
    return fbReachCharts.find((fbReachChart) => fbReachChart.name === name);
};

export const getFbImpressionCharts = (name) => {
    return fbImpressionCharts.find((fbReachChart) => fbReachChart.name === name);
};

export const getFbPostLikesChart = (name) => {
    return fbPostLikesCharts.find((fbPostLikesChart) => fbPostLikesChart.name === name);
};

export const getAudienceByGenderChart = (name) => {
    return audienceByGenderCharts.find((chart) => chart.name === name);
};

export const getAudienceByCountryChart = (name) => {
    return audienceByCountryCharts.find((chart) => chart.name === name);
};

export const getAudienceByAgeChart = (name) => {
    return audienceByAgeCharts.find((chart) => chart.name === name);
};

export const getPageOptions = (arr) => {
    let defaultOption = { key: "default", text: "Select Page", value: "default", disabled: true };
    let allOptions = arr.map((elem) => {
        return { key: elem.name, text: elem.name, value: parseInt(elem.id) };
    });
    return [defaultOption, ...allOptions];
};

export function getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export const sortFbPages = (arr = []) => {
    if (arr) {
        let active = arr.filter((page) => page.status === "Active").sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        let inactive = arr.filter((page) => page.status === "Inactive").sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        let expired = arr.filter((page) => page.status === "Expired").sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        const fbSelectedPageIds = [...active, ...inactive, ...expired];

        const facebookPageOptions = [];
        fbSelectedPageIds.map((k, v) => {
            let status = k.status;
            if (k.status === "Active" && k.expiry_date == undefined) {
                status = "Active";
            } else if (k.status === "Active" && moment(new Date()).diff(k.expiry_date, "days") < 0 && moment(new Date()).diff(k.expiry_date, "days") > -6)
                status = "Expiring Soon";
            else if (k.status === "Active" && moment(new Date()).isAfter(k.expiry_date)) status = "Expired";
            facebookPageOptions.push({
                key: k.id,
                label: `${k.username} (${status})`,
                value: k.id,
                status,
                expiry_date: k.expiry_date,
                id: k.id,
                access_token: k.access_token,
                handler: k.handler,
            });
        });

        return facebookPageOptions;
    }

    return [];
};
